import React from "react";

/**
 * FormGrid - Grid-based form layout
 *
 * Wrap FormField components inside FormGrid for automatic grid layout
 */
const FormGrid = ({ children }) => {
	return <div className="form-grid">{children}</div>;
};

/**
 * FormField - Individual form field with label
 *
 * @param {string} label - Field label
 * @param {string} name - Input name
 * @param {string} width - Width: "full" (default), "half", "third", "two-thirds", "quarter"
 * @param {boolean} required - Show required indicator
 * @param {string} error - Error message
 * @param {string} help - Help text
 * @param {node} children - Input element
 */
export const FormField = ({
	label,
	name,
	width = "full",
	required = false,
	error,
	help,
	children,
}) => {
	const classNames = [
		"form-grid__field",
		`form-grid__field--${width}`,
		error && "form-grid__field--error",
	].filter(Boolean).join(" ");

	return (
		<div className={classNames}>
			{label && (
				<label htmlFor={name}>
					{label}
					{required && <span className="required">*</span>}
				</label>
			)}
			{children}
			{error && <span className="form-grid__error">{error}</span>}
			{help && !error && <span className="form-grid__help">{help}</span>}
		</div>
	);
};

/**
 * FormSection - Section divider with title
 *
 * @param {string} title - Section title
 */
export const FormSection = ({ title, children }) => {
	return (
		<div className="form-grid__section">
			{title && <h3 className="form-grid__section-title">{title}</h3>}
			{children}
		</div>
	);
};

export default FormGrid;
